import TableThingyView from '../view/table_view';
import {connect} from "react-redux";
import { RootState } from "../../../app/store"
import { Dispatch } from '@reduxjs/toolkit';
import { requestDataFromAPI, requestRemoveLicence, requestRemoveLicences, requestRestoreLicence} from '../thunk/table_tunc';
import { ADMIN_ROLE } from '../../UpdateInputThingy/typing/emergencyUpload';

interface OwnProps {
    id:string;
}

function mapStateToProps(state:RootState, ownProps:OwnProps){  
    const myprops=
    {
        TargetTable_data:state.TargetTable.model,
        view:state.TargetTable.view,
        isAdmin:state.LoginManager.model.role === ADMIN_ROLE,
    }
    return myprops;
}

function bindDispatchToActions(dispatch:Dispatch<any>, ownProps:OwnProps){
    return {
        onLoadRequested:(includeArchived:boolean)=>{ 
            dispatch(requestDataFromAPI(includeArchived) as any);
        },
        onRemove:(uuid:string, includeArchived:boolean, inUseText:string)=>{
            dispatch(requestRemoveLicence(uuid, inUseText, () => dispatch(requestDataFromAPI(includeArchived) as any)) as any);
        },
        onRemoveSeveral:(uuids:string[], includeArchived:boolean,
                         texts:{ summary:(archived:number, unchanged:number, refused:number) => string, failed:string })=>{
            dispatch(requestRemoveLicences(uuids, texts, () => dispatch(requestDataFromAPI(includeArchived) as any)) as any);
        },
        onRestore:(uuid:string, includeArchived:boolean)=>{
            dispatch(requestRestoreLicence(uuid, () => dispatch(requestDataFromAPI(includeArchived) as any)) as any);
        },
    }
}


const LicenseListContainer=connect(mapStateToProps, bindDispatchToActions)(TableThingyView);
export default LicenseListContainer;